var GridColumn = function(params){
    var self = this;
    self.name = ko.observable(params && params.name || '');
    self.label = ko.observable(params && params.label || '');
    self.selected = ko.observable(params && params.selected || true);
};